// @ts-check
import { Tag } from "antd";
import ManageFormsActions from '~/components/AdminPages/ManageForms/ManageFormsActions';
import ButtonLink from '~/components/Shared/ButtonLink';
import { useZeroContext } from '~/components/ZeroContext';
import useOrganizationId from '~/hooks/useOrganizationId';
import { updateHistoryState } from '~/other/Helper';
import { FormType } from '~/other/Constants';
import { Link, useHistory } from "react-router-dom";
import { useTemplateDataGridContext } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.context';
import { EventNames, getTemplateAnalyticsLink } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.utils';
/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function TemplateActionCell({data: form}) {
    const context = useZeroContext();

    if (!form) {
        return null;
    }

    return (
        <ManageFormsActions
            forDataGrid
            form={form}
            onDelete={() => {
                context.events.emit(EventNames.REFRESH_DATA);
            }}
            refresh={() => {
                context.events.emit(EventNames.REFRESH_DATA);
            }}
        />
    );
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function TemplateNameCell({data: form, value: name, api}) {
    const history = useHistory();
    const orgId = useOrganizationId();

    if (!form) {
        return null;
    }

    const linkUrl = getTemplateAnalyticsLink(form, orgId, form.form_type);

    const onClick = () => {
        updateHistoryState(history, {gridState: api.getState()});
    }

    return (
        <div className="flex gap-sm" style={{ alignItems: "center" }}>
            <Link to={linkUrl} className="blue-link" onClick={onClick}>
                {name}
            </Link>
            {form.is_public && (
                <Tag color="green" style={{ borderColor: "#52c41a", fontSize: "11px" }}>
                    Public
                </Tag>
            )}
        </div>
    );
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function TemplateTypeCell({data: form, value}) {
    if (!form) {
        return null;
    }
    
    const type = form.schedule_only ? "Schedule Only" : FormType.mapToName(form.form_type);
    return (
        <span className="zero-dark-grey" style={{ fontWeight: "400" }}>
            {type}
        </span>
    );
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function TemplateTeamsCell({data: form}) {
    const { setActiveModal } = useTemplateDataGridContext();

    if (!form) {
        return null;
    }

    if (form.form_type === FormType.INCIDENT) {
        return <span style={{ fontWeight: "400" }}>N/A</span>;
    } else {
        const teamCount = form.share_teams_count ?? 0;
        
        const handleClick = () => {
            setActiveModal({
                key: 'teams',
                form
            });
        };

        return (
            <div>
                <ButtonLink onClick={handleClick}>
                    {teamCount}
                </ButtonLink>
            </div>
        );
    }
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function TemplateScheduleCell({data: form}) {
    const { setActiveModal } = useTemplateDataGridContext();

    if (!form) {
        return null;
    }

    const scheduleCount = form.schedulers_count;

    const handleClick = () => {
        setActiveModal({
            key: 'schedules',
            form
        });
    };

    if (scheduleCount > 0) {
        return (
            <ButtonLink onClick={handleClick}>
                Yes
            </ButtonLink>
        );
    } else {
        return (
            <span className="zero-dark-grey" style={{ fontWeight: "400" }}>
                No
            </span>
        );
    }
} 